"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseTextComponent = void 0;
const core_1 = require("@angular/core");
let CollapseTextComponent = class CollapseTextComponent {
    constructor() {
        this.isCollapsed = true;
    }
};
exports.CollapseTextComponent = CollapseTextComponent;
__decorate([
    (0, core_1.Input)('title'),
    __metadata("design:type", String)
], CollapseTextComponent.prototype, "title", void 0);
__decorate([
    (0, core_1.Input)('copy'),
    __metadata("design:type", String)
], CollapseTextComponent.prototype, "copy", void 0);
exports.CollapseTextComponent = CollapseTextComponent = __decorate([
    (0, core_1.Component)({
        moduleId: module.id.toString(),
        selector: 'collapse-text-component',
        template: `
    <div class="clickable copyTitle padBottom" (click)="isCollapsed = !isCollapsed">
      <i class="fa brtBlue" [ngClass]="{'fa-minus-square-o': !isCollapsed, 'fa-plus-square-o': isCollapsed}"></i> {{title}}
    </div>
    <div [collapse]="isCollapsed" class="card card-block card-header">
    <div class="well well-lg copyBody" [innerHTML]="copy" #el></div>
    </div>
  `,
        styleUrls: ['/styles/collapse-text.component.css'],
    })
], CollapseTextComponent);
//# sourceMappingURL=collapse-text.component.js.map